<template>
    <v-container :fluid="$vuetify.breakpoint.md" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col cols="12">
                <v-card>
                    <v-card-title class="d-block text-center font-weight-bold primary secondary--text pa-1" style="word-break: normal">PARTICIPANTES</v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getData">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                    <v-card-text class="pa-4">
                        <v-data-table
                            :headers="headers"
                            :items="accounts"
                            :loading="loading"
                            no-data-text="Sin participantes activos"
                            :footer-props="footerProps">
                            <template v-slot:item.user_status="{ item }">
                                <v-chip small label :color="item.user_status === 103 ? 'success' : 'tertiary'" :dark="item.user_status === 103">
                                    {{ item.user_status === 103 ? 'Verificado' : 'Pendiente' }}
                                </v-chip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "Participants",
    data: () => ({
        loading: true,
        accounts: [],
        headers: [
            { text: 'Cliente', value: 'name' },
            { text: 'Nickname', value: 'nickname' },
            { text: 'Puntos', value: 'points_balance', align: 'right' },
            { text: 'Ganados', value: 'total_earned_points', align: 'right' },
            { text: 'Canjeados', value: 'total_redeemed_points', align: 'right' },
            { text: 'Wallet', value: 'cash_redeemed_usdt', align: 'right' },
            { text: 'Estado', value: 'user_status', align: 'center' },
        ],
        footerProps: {
            itemsPerPageOptions: [25, 50, 100, 200]
        }
    }),
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/rewards/admin').then(res => {
                const rewards = res.data.rewards || {};
                this.accounts = rewards.accounts || [];
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar participantes.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        errorMessage(err, fallback) {
            if (err.response && err.response.data && err.response.data.status) {
                return err.response.data.status;
            }

            return fallback;
        }
    }
}
</script>

<style scoped>

</style>
